import { defineComponent } from "vue";
export default defineComponent({
  props: {
    showLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeOverlay() {
      this.$emit("close");
    }
  },
  setup() {}
});